import * as React from 'react';
import styled from '../../styled-components';
export const LogoImgEl = styled.img(["max-height:", ";max-width:", ";width:100%;display:block;"], props => props.theme.logo.maxHeight, props => props.theme.logo.maxWidth);
export const LogoWrap = styled.div(["text-align:center;"]);
const Link = styled.a(["display:inline-block;"]);
export const LinkWrap = url => Component => <Link href={url}>{Component}</Link>;